import React from "react";
import classNames from "classnames/bind";
import { useLocation, useNavigate } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { useRecruitment } from "../../../../context/RecruitmentContext";
import {
  getCampaignNavigatePath,
  linkifyCampaignIdMarkers,
} from "../../../../utils/constants/chatMessageUtils";
import styles from "./index.module.sass";

const cx = classNames.bind(styles);

const CampaignMarkdownLink = ({ href, children, ...props }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { selectChatCampaign } = useRecruitment();

  const campaignMatch =
    typeof href === "string" && href.match(/^\/(\d+)$/);

  if (campaignMatch) {
    const campaignId = campaignMatch[1];

    return (
      <button
        type="button"
        className={cx("campaignMarkdownLink")}
        onClick={() => {
          if (!selectChatCampaign(campaignId)) return;
          navigate(getCampaignNavigatePath(campaignId, location.pathname));
        }}
      >
        {children}
      </button>
    );
  }

  return (
    <a href={href} target="_blank" rel="noopener noreferrer" {...props}>
      {children}
    </a>
  );
};

const ChatMarkdownContent = ({ content }) => {
  if (!content) return null;

  const prepared = linkifyCampaignIdMarkers(content);

  return (
    <div className={cx("markdownContent")}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{ a: CampaignMarkdownLink }}
      >
        {prepared}
      </ReactMarkdown>
    </div>
  );
};

export default ChatMarkdownContent;
